import axios from 'axios';

import { request, archive } from '../../../helpers/requests';
import { formatPayloadCustomData } from '../../../equipment/state/equipment.service';


export default {
  create: async (payload) => {
    const newPayload = { ...payload };
    const {
      customData: formattedCustomData,
      files: formattedFiles,
    } = await formatPayloadCustomData(payload.customData);
    newPayload.customData = formattedCustomData;
    newPayload.files = formattedFiles;

    return request({
      call: axios.post('/customers', newPayload),
      errMsg: 'Could not create customer',
    });
  },
  get: () => request({
    call: axios.get('/customers'),
    errMsg: 'Could not get customers',
    hideSuccessToast: true,
  }),
  archive: (id, active) => archive({
    id, active, type: 'customers',
  }),
  bulkArchive: (ids, { password, active }) => request({
    call: axios.put('/customers/bulk-archive', { ids, password, active }),
    errMsg: `Could not ${active ? 'activate' : 'archive'} customers`,
    successMsg: `Customers successfully ${active ? 'reactivated' : 'archived'}`,
  }),
  update: async (id, payload) => {
    const newPayload = { ...payload };
    const {
      customData: formattedCustomData,
      files: formattedFiles,
    } = await formatPayloadCustomData(payload.customData);
    newPayload.customData = formattedCustomData;
    newPayload.files = formattedFiles;

    return request({
      call: axios.put(`/customers/${id}`, newPayload),
      errMsg: 'Could not update customer',
    });
  },
  delete: (id) => request({
    call: axios.delete(`/customers/${id}`),
    errMsg: 'Could not delete customer',
  }),
  bulkDelete: (ids, { password }) => request({
    call: axios.post('/customers/bulk-delete', { ids, password }),
    errMsg: 'Could not delete customers',
    successMsg: 'Customers deleted successfully',
  }),
  getNotes: (id) => request({
    call: axios.get(`/customers/${id}/notes`),
    errMsg: 'Could not get customer notes',
    hideSuccessToast: true,
  }),
  addNote: (id, { text, tags, files }) => request({
    call: axios.post(`/customers/${id}/note`, { note: text, tags, files }),
    errMsg: 'Could not create note',
  }),
  getClientComms: (id) => request({
    call: axios.get(`/clientPortal/comms/${id}/notes`),
    errMsg: 'Could not get client messages',
    hideSuccessToast: true,
  }),
  addClientComm: (payload) => request({
    call: axios.post('/clientPortal/comms/note/outgoing', payload),
    errMsg: 'Could not add client message',
  }),
  getUnreadClientComms: () => request({
    call: axios.get('/clientPortal/comms/unread'),
    errMsg: 'Could not get unread client messages',
    hideSuccessToast: true,
  }),
  markAsRead: (ids) => request({
    call: axios.post('/clientPortal/comms/read/incoming', { ids }),
    errMsg: 'Could not mark messages as read',
    hideSuccessToast: true,
  }),
  getClientBroadcasts: () => request({
    call: axios.get('/clientPortal/comms/broadcasts'),
    errMsg: 'Could not get client broadcast messages',
    hideSuccessToast: true,
  }),
  getCustomerLabels: () => request({
    call: axios.get('/customers/labels'),
    errMsg: 'Could not get customer labels',
    hideSuccessToast: true,
  }),
  getMyCustomerTags: (hasRead = false) => request({
    call: axios.get('/customers/notes/tags', { params: { hasRead } }),
    errMsg: 'Could not get customer tags',
    hideSuccessToast: true,
  }),
  markCustomerTagsAsRead: (noteIds) => request({
    call: axios.put('/customers/notes/read', { ids: Array.from(noteIds) }),
    errMsg: 'Could not mark customer tags as read',
    hideSuccessToast: true,
  }),
  getCustomFieldTemplate: () => request({
    call: axios.get('/customers/customFieldTemplate'),
    errMsg: 'Failed to get customer custom field template',
    hideSuccessToast: true,
  }),
  updateCustomFieldTemplate: (payload) => request({
    call: axios.post('/customers/customFieldTemplate', payload),
    errMsg: 'Failed to update customer custom field template',
  }),
  getCustomData: (id) => request({
    call: axios.get(`/customers/${id}/data`, { params: { getSignedUrls: false } }),
    errMsg: 'Failed to get customer custom data',
    hideSuccessToast: true,
  }),
};
